.tests {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.title {
  font-size: 28px;
}

.group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.heading {
  font-size: 17px;
}

.empty {
  color: var(--ink-2);
}

/* One card per row on a phone, two side by side on a desktop. */
.grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
}

@media (min-width: 720px) {
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.list {
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-top: 1.5px solid var(--ink);
  color: var(--ink);
  text-decoration: none;
}

.row:first-child {
  border-top: 0;
}

.what {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.name {
  font-size: 16px;
  font-weight: 600;
}

.when {
  font-size: 14px;
  color: var(--ink-2);
}

.chip {
  padding: 4px 10px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  background: var(--accent-soft);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.chevron {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  background-color: var(--ink-3);
  -webkit-mask: url('./chevron.svg') no-repeat center / contain;
  mask: url('./chevron.svg') no-repeat center / contain;
}
